import { createStore } from 'easy-peasy'
import formatData from './utils/formatData'
// import data from './campaigns/bexident2020.json'
// import data from './campaigns/03-20_melanoma.json'
import steps from './models/steps'
import form from './models/form'
import quiz from './models/quiz'
import landing from './models/landing'
import locale from './models/locale'

export default localeData =>
  createStore(
    {
      steps,
      form,
      quiz,
      landing,
      locale,
    },
    {
      name: 'serverless-landings',
      initialState: formatData(localeData),
    },
  )
